import Deferred from "csi/_base/Deferred";
import declare from "dojo/_base/declare";
import when from "dojo/when";
import StoreNamesConstructor, { StoreNames } from "./Names";
import _ClientRequestMixin from "./_ClientRequestMixin";
import { isDefined } from "csi/utility/coreUtility";

export = declare([StoreNamesConstructor, _ClientRequestMixin], {
	/** @property {emptyName} emptyName - name to use for empty value, if any */
	emptyName: null,

	/** @property {RequestStore} sourceStore - source store holding data that will populate names */
	sourceStore: null,

	constructor() {
		// Names store set loaded to true if no request provided, so need to override that to call _resolveData
		this.namesStore()._loaded = false;
	},

	/**
	 * Return this as names store
	 * @returns 
	 */
	namesStore(): StoreNames {
		return this as unknown as StoreNames;
	},

	/**
	 * @override
	 * Query data from source store and map to names store
	 */
	_resolveData(dfd: Deferred): void {
		const { emptyName, sourceStore } = this;
		const { idProperty, nameProperty } = sourceStore;
		const {
			emptyValue,
			idProperty: thisIdProperty,
			nameProperty: thisNameProperty,
		} = this.namesStore();

		when(sourceStore.query(), (results) => {
			const data = results.map((result: Record<string, any>) => ({
				[thisIdProperty]: result[idProperty],
				[thisNameProperty]: result[nameProperty],
			}));

			if (isDefined(emptyName)) {
				data.unshift({
					[thisIdProperty]: emptyValue,
					[thisNameProperty]: emptyName,
				});
			}

			dfd.resolve(data);
		});
	},
});